import { useTheme } from '@/hooks/useTheme';
import PromoVideo from '@/components/common/PromoVideo';
import PlayCtaButton from '@/components/common/PlayCtaButton';
import { GAMEPLAY_VIDEO_ID } from '@/lib/constants';

export default function HeroSection() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <section className="relative flex flex-col items-center min-h-screen px-6 pt-8 sm:pt-12 pb-16 text-center overflow-hidden">
      {/* Radial glow behind logo */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_50%_45%,hsl(var(--accent-gold)/0.06),transparent_70%)]" />
      <div
        className="absolute bottom-4 left-0 right-0 h-px"
        style={{
          background:
            'linear-gradient(to right, transparent, hsl(var(--accent-gold) / 0.3), transparent)',
        }}
      />

      <div className="relative z-10 flex flex-col items-center gap-6">
        <img
          src={isDark ? '/polymyth_logo_v1_final_dark.png' : '/polymyth_logo_v1_final_lite.png'}
          alt="Polymyth"
          className="h-14 sm:h-20 lg:h-24 w-auto"
        />

        <p className="text-3xl sm:text-4xl lg:text-5xl font-character text-foreground">
          Roleplay Adventures for Everyone
        </p>

        <PlayCtaButton label="Start Playing" size="lg" />

        <PromoVideo
          videoId={GAMEPLAY_VIDEO_ID}
          title="Polymyth Playthrough: Zero to Adventure in 60 Seconds"
          className="w-[min(90vw,52rem)]"
        />
      </div>
    </section>
  );
}
